// Which form the visitor is on, for the audit trail's Origin columns.
//
// A separate module on purpose: Store.js imports axiosClient from api.ts, so api.ts importing the
// store back would be a circular import. Both import this instead.
let current: string | null = null;

export function setOrigin(type: string, id: number | string | null | undefined): void {
  current = id === null || id === undefined || id === '' ? null : `${type}/${id}`;
}

export function getOrigin(): string | null {
  return current;
}
